/**
 * HeroImageSectionFront.jsx
 * Created by Destin Frasier on 08/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
};

export default class HeroImageSectionFront extends React.PureComponent {
    render() {
        return (
            <div className="rec-section-hero-body-outer-wrap">
                <div className="rec-section-hero-body">
                    <h1 className="rec-section-hero-title">{this.props.title}</h1>
                    {
                        this.props.text.length > 0 &&
                        <p className="rec-section-hero-text">{this.props.text}</p>
                    }
                </div>
            </div>
        );
    }
}

HeroImageSectionFront.propTypes = propTypes;
